import React from 'react';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

const RadioField = ({ config, value, onChange }) => {
    if (config.field_type !== 'radio') return null;
    
    return (
        <FormControl component="fieldset">
            <RadioGroup
                row
                name={config.id}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
            >
                {config.options && config.options.map((option, index) => (
                    <FormControlLabel
                        key={index}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default RadioField;